import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultIpProfile'
})
export class DefaultIpProfilePipe implements PipeTransform {

  transform(value: any, row: any): any {
    if (row.defaultProfile) {
      return value + ' <b>(Default)<b>';
    }
    return value;
  }

}
